import { render, staticRenderFns } from "./DialogAnnounce.vue?vue&type=template&id=32f6439f&scoped=true"
import script from "./DialogAnnounce.vue?vue&type=script&lang=js"
export * from "./DialogAnnounce.vue?vue&type=script&lang=js"
import style0 from "./DialogAnnounce.vue?vue&type=style&index=0&id=32f6439f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6439f",
  null
  
)

export default component.exports